import { apiFetch } from '../../api/api'; // or wherever apiFetch lives

const BASE_URL = '/templates';

export const getAllTemplates = async ({ cnt = 0, lmt = 100 } = {}) => {
  const res = await apiFetch(`${BASE_URL}/gettemplates`, {
    method: 'POST',
    body: {
      cnt,
      lmt,
    },
  });
  // 🔑 UNWRAP HERE
  return res.items || [];
};

export const getTemplateById = async (id) => {
  return apiFetch(`${BASE_URL}/getTemplateById/${id}`);
};
